import { render, staticRenderFns } from "./AddAccidentModal.vue?vue&type=template&id=3fa8e20b&scoped=true&"
import script from "./AddAccidentModal.vue?vue&type=script&lang=js&"
export * from "./AddAccidentModal.vue?vue&type=script&lang=js&"
import style0 from "./AddAccidentModal.vue?vue&type=style&index=0&id=3fa8e20b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa8e20b",
  null
  
)

export default component.exports